const reduceObject =
	obj =>
	(...args) =>
		Object.entries(obj).reduce(...args)

const getCSSColorVariables = colors => reduceObject(colors)((acc, [k, v]) => `${acc}\n\t--color-${k}: ${v};`, '')

const getSelector = (key, index) => (!index ? `:root, [data-theme='${key}']` : `[data-theme='${key}']`)

const wrapThemeSelector = (key, index) => content => `${getSelector(key, index)} {\t${content}\n}\n`

const generateCSSColorVariables = ({ theme: { colors } }) =>
	reduceObject(colors)((acc, [k, v], i) => acc + wrapThemeSelector(k, i)(getCSSColorVariables(v)), '')

export default generateCSSColorVariables
